exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".summary-contract-pricing{display:block;margin-left:15px}.payment-summary-text{margin:0}.price-with-discount{text-decoration:line-through}.less-padding-section{margin-top:16px;margin-bottom:16px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/payment/Summary/Summary.scss
 ** module id = 1254
 ** module chunks = 0
 **/